import axios from 'axios';
import { REACT_APP_WORKING_URL } from '../Constants'
import { REACT_APP_WORKING_CHATAPI_URL } from '../Constants'

const chatApiUrl = REACT_APP_WORKING_CHATAPI_URL


const updateHistoryFeedback = async (id, feedback) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));

    const res = await axios.post(`${REACT_APP_WORKING_URL}chatting/updateHistoryFeedback`, {
        msgId: id,
        feedback: feedback
    }, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;

}


// quiz requests
const getQuizList = async (userId) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getQuizList/${userId}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const getQuestionsByQuesIds = async (quesIds) => {
    console.log('quesIds', quesIds);
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/getQuestionsByQuesIds`, { questionIds: quesIds }, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}



const getAnswersByQuizId = async (quizId, attemp) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getAnswersByQuizId`, {
        params: {
            quiz_id: quizId,
            attemp: attemp,
        },
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const getLastSubmitHistory = async (userId) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getLastSubmitHistory/${userId}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const createQuiz = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/createQuiz`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const createQuizDetail = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/createQuizDetail`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const createQuestions = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/createQuestions`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const getQuizDetail = async (quizId, quizType) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getQuizDetail/${quizId}/${quizType}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const createQuizSubmit = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/createQuizSubmit`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const createQuestionSubmit = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/createQuestionSubmit`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const duplicateQuizByQuizId = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/duplicateQuizByQuizId`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}



const getQuizTheme = async (userId) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getQuizTheme/${userId}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const getQuesBankStatusList = async (userId) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getQuesBankStatusList/${userId}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const createNewQuizFromQuesBank = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}quiz/createNewQuizFromQuesBank`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}



const getWrongQuesQzNumByThm = async (theme) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getWrongQuesQzNumByThm/${theme}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const getRandQuesQzNumByThm = async (theme) => {
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getRandQuesQzNumByThm/${theme}`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

const deleteDocument = async (formData) => {
    const res = await axios.post(`${chatApiUrl}document_delete/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
    return res.data;
}

const getSubmitStatic = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getSubmitStatic`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
        params: data,
    });
    return res.data;
}
const getSubmitDetail = async (data) => {
    const userInStorage = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getSubmitDetail`, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
        params: data,
    });
    return res.data;
}



export {
    updateHistoryFeedback,
    getQuizList,
    createQuiz,
    getQuizDetail,
    createQuizDetail,
    createQuizSubmit,
    duplicateQuizByQuizId,
    getLastSubmitHistory,
    getQuizTheme,
    getWrongQuesQzNumByThm,
    getRandQuesQzNumByThm,
    getQuesBankStatusList,
    deleteDocument,
    createQuestions,
    getQuestionsByQuesIds,
    createQuestionSubmit,
    getAnswersByQuizId,
    getSubmitStatic,
    getSubmitDetail,
}